import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-596d2671"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {"width":"100%"},
  class: "text-center"
}, [
  /*#__PURE__*/_createTextVNode(" 준비 중입니다."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createTextVNode("조금만 기다려주세요 :) ")
], -1))

import { ref, watch } from 'vue';
  import { ColorVariants } from '@/constants';

  
export default /*#__PURE__*/_defineComponent({
  props: {
    modelValue: { type: Boolean }
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: emits }: { emit: ({(e: 'update:modelValue', val: boolean): void }), expose: any, slots: any, attrs: any }) {

const props = __props as { modelValue: boolean }

  
  

  const dialog = ref(false);

  watch(() => props.modelValue, val => {
    dialog.value = val;
  });


return (_ctx: any,_cache: any) => {
  const _component_AppDialog = _resolveComponent("AppDialog")!

  return (_openBlock(), _createBlock(_component_AppDialog, {
    visible: dialog.value,
    "onUpdate:visible": _cache[0] || (_cache[0] = ($event: any) => ((dialog).value = $event)),
    class: "wait-dialog",
    btns: [
      { text: '닫기', style: _unref(ColorVariants).dark, click: () => emits('update:modelValue', false) }
    ]
  }, {
    default: _withCtx(() => [
      _hoisted_1
    ]),
    _: 1
  }, 8, ["visible", "btns"]))
}
}

})